// A tiny "the access token changed" signal.
//
// The axios refresh interceptor rotates both tokens straight into
// localStorage, and redux never hears about it (auth.userToken is only set on
// login). The shop websocket authenticates with the token it was opened with,
// so it needs to know when to reconnect. A window event keeps request.js free
// of any store or React import.
//
// Cross-tab rotation arrives as the browser's own `storage` event, which only
// fires in the *other* tabs — exactly the ones that did not run the refresh.

export const TOKEN_REFRESHED_EVENT = "canasale:token-refreshed";

const AUTH_KEY = "authorizationData";

export const notifyTokenRefreshed = () => {
  if (typeof window === "undefined" || !window?.dispatchEvent) {
    return;
  }
  window.dispatchEvent(new Event(TOKEN_REFRESHED_EVENT));
};

// Calls `callback` whenever the stored session changes in this tab (refresh)
// or another one (refresh, login, logout). Returns the unsubscribe function.
export const subscribeTokenChanges = (callback) => {
  if (typeof window === "undefined" || !window?.addEventListener) {
    return () => {};
  }
  const onStorage = (event) => {
    // key === null means localStorage.clear()
    if (event?.key === AUTH_KEY || event?.key === null) {
      callback();
    }
  };
  window.addEventListener(TOKEN_REFRESHED_EVENT, callback);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(TOKEN_REFRESHED_EVENT, callback);
    window.removeEventListener("storage", onStorage);
  };
};
